<div class="main" class="d-flex flex-row w-100">
  <div class="mainBox p-3 w-33">
    <div>
      <h3 class="color-primary border-bottom-custom">System Information</h3>
    </div>
    <div *ngIf="!systemInfoDetails">
      <p>No System Information available</p>
    </div>
    <div *ngIf="systemInfoDetails">
      <div class="parContainer">
        <p class="propertyTitle">Host Name</p>
        <p class="propertyValue">{{ systemInfoDetails.hostname }}</p>
      </div>
      <div class="parContainer">
        <p class="propertyTitle">Internet Connection</p>
        <p class="propertyValue">
          {{ systemInfoDetails.internetConnection }}
        </p>
      </div>
      <div class="parContainer">
        <p class="propertyTitle">Operating system</p>
        <p class="propertyValue">
          {{ systemInfoDetails.operatingSystem.name }}
        </p>
      </div>
      <div class="parContainer">
        <p class="propertyTitle">Uptime</p>
        <p class="propertyValue">{{ systemInfoDetails.uptime }}</p>
      </div>
      <div class="parContainer">
        <p class="propertyTitle">External Ips</p>
        <p class="propertyValue">{{ systemInfoDetails.externalIP }}</p>
      </div>
      <div class="parContainer">
        <p class="propertyTitle">Internal Ips</p>
        <p class="propertyValue">
          <select>
            <option *ngFor="let ip of systemInfoDetails.internalIPs">
              {{ ip }}
            </option>
          </select>
        </p>
      </div>
      <div class="parContainer">
        <p class="propertyTitle">Logged In Users</p>
        <p
          *ngIf="systemInfoDetails.loggedInUsers.length > 0"
          class="propertyValue"
        >
          <select>
            <option *ngFor="let user of systemInfoDetails.loggedInUsers">
              {{ user }}
            </option>
          </select>
        </p>
        <p
          *ngIf="systemInfoDetails.loggedInUsers.length == 0"
          class="propertyValue"
        >
          NA
        </p>
      </div>
    </div>
  </div>
  <div class="mainBox p-3" style="width: 65%">
    <div>
      <h3 class="color-primary border-bottom-custom">Metrics Information</h3>
    </div>
    <div *ngIf="!metricsInfo">
      <p>No Metrics Information available</p>
    </div>
    <div *ngIf="metricsInfo" class="d-flex">
      <div class="w-33">
        <h5 class="mb-1 fw-bold color-primary">CPU</h5>
        <div style="padding-left: 10px">
          <div class="parContainer">
            <p class="propertyTitle">CPU usage</p>
            <p class="propertyValue">{{ metricsInfo.cpu.usage_percent }}%</p>
          </div>
        </div>
      </div>
      <div class="w-33">
        <h5 class="mb-1 fw-bold color-primary">RAM</h5>
        <div style="padding-left: 10px">
          <div class="parContainer">
            <p class="propertyTitle">Total RAM</p>
            <p class="propertyValue">{{ metricsInfo.ram.total_mb }} MB</p>
          </div>
          <div class="parContainer">
            <p class="propertyTitle">Buff Cache</p>
            <p class="propertyValue">{{ metricsInfo.ram.buff_cache_mb }} MB</p>
          </div>
          <div class="parContainer">
            <p class="propertyTitle">Used</p>
            <p class="propertyValue">{{ metricsInfo.ram.used_mb }} MB</p>
          </div>
          <div class="parContainer">
            <p class="propertyTitle">Free</p>
            <p class="propertyValue">{{ metricsInfo.ram.free_mb }} MB</p>
          </div>
          <div class="parContainer">
            <p class="propertyTitle">Usage (%)</p>
            <p class="propertyValue">{{ metricsInfo.ram.usage_percent }}%</p>
          </div>
        </div>
      </div>

      <div class="w-33">
        <h5 class="mb-1 fw-bold color-primary">SWAP</h5>
        <div style="padding-left: 10px">
          <div class="parContainer">
            <p class="propertyTitle">Total SWAP</p>
            <p class="propertyValue">{{ metricsInfo.swap.total_mb }} MB</p>
          </div>
          <div class="parContainer">
            <p class="propertyTitle">Buff Cache</p>
            <p class="propertyValue">{{ metricsInfo.swap.buff_cache_mb }} MB</p>
          </div>
          <div class="parContainer">
            <p class="propertyTitle">Used</p>
            <p class="propertyValue">{{ metricsInfo.swap.used_mb }} MB</p>
          </div>
          <div class="parContainer">
            <p class="propertyTitle">Free</p>
            <p class="propertyValue">{{ metricsInfo.swap.free_mb }} MB</p>
          </div>
          <div class="parContainer">
            <p class="propertyTitle">Usage (%)</p>
            <p class="propertyValue">{{ metricsInfo.swap.usage_percent }}%</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="p-3">
  <h3 class="color-primary border-bottom-custom">Disk Usage</h3>
  <div *ngIf="!diskUsage?.filesystems">
    <p style="margin: 0; font-size: 12px">No Disk Information available</p>
  </div>
  <div *ngIf="diskUsage?.filesystems" class="w-100">
    <table class="table table-hover">
      <thead>
        <tr  class="table-list-head"
          style="
            color: White;
            background-color: var(--s-primary-color);
            height: 2rem;
          "
        >
          <th>Filesystem</th>
          <th>Size</th>
          <th>Used</th>
          <th>Available</th>
          <th>Use Percentage</th>
          <th>Mounted On</th>
        </tr>
      </thead>
      <tbody *ngIf="diskUsage">
        <tr class="table-list-row" *ngFor="let item of diskUsage.filesystems">
          <td class="color-primary">{{ item.filesystem }}</td>
          <td>{{ item.size }}</td>
          <td>{{ item.used }}</td>
          <td>{{ item.available }}</td>
          <td>{{ item.use_percent }}</td>
          <td>{{ item.mounted_on }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
